import { Translate } from '@deltasierra/components';
import { AppFrontendRoutes } from '@deltasierra/frontend-routing-app-frontend';
import { ServiceName } from '@deltasierra/integrations-integration-types';
import { URLParamsBuilder } from '@deltasierra/shared';
import ArrowForward from '@material-ui/icons/ArrowForward';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useLocationFeatures } from '../../common/locationFeatures';
import { useDeprecatedAppFrontendRouter } from '../hooks/useAppFrontendRouter';

export interface ConnectPageLinkProps {
    customMessage?: string;
    locationId?: string;
    platform?: ServiceName;
    showArrow?: boolean;
}
export const ConnectPageLink: React.FC<ConnectPageLinkProps> = ({
    customMessage,
    locationId,
    platform,
    showArrow = false,
}) => {
    const appFrontendRouter = useDeprecatedAppFrontendRouter();
    const { enableNewConnectPage: isNewConnectionsPageEnabled } = useLocationFeatures(locationId ?? null);

    const connectPageUrl = React.useMemo(() => {
        let url = '/connect';
        const searchParams = new URLParamsBuilder();
        if (platform) {
            searchParams.add('pn', platform);
        }
        if (locationId && !isNewConnectionsPageEnabled) {
            searchParams.add('locationId', locationId);
        }
        if (isNewConnectionsPageEnabled) {
            url = appFrontendRouter?.get(`/${AppFrontendRoutes.Connections}`) ?? url;
        }
        const params = searchParams.build();
        if (params) {
            url += `?${params}`;
        }
        return url;
    }, [appFrontendRouter, isNewConnectionsPageEnabled, locationId, platform]);

    return (
        <Link to={connectPageUrl}>
            {customMessage ? customMessage : <Translate keyId="COMMON.CONNECT_PAGE.CONNECT_PAGE" />}
            {showArrow && <ArrowForward style={{ marginLeft: '5px', position: 'fixed' }} />}
        </Link>
    );
};
ConnectPageLink.displayName = 'ConnectPageLink';
